import api, { getApiErrors } from '@app/services/api';
import type { ApiError, InteractionListParams } from '@app/services/api.types';
import { fn } from '@app/utils';
import { apiEndpoints, defaultErrorMessage } from '@app/utils/constants';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import useApp from '../useApp';

export const exportContactList = async (params: InteractionListParams) => {
    const url = apiEndpoints.interactions.getListExport(params);
    const response = await api.get<Blob>(url, {
        responseType: 'blob',
    });
    return response;
};

const useInterationsActions = () => {
    const { message } = useApp();

    const exportInteractions = useMutation<
        AxiosResponse<Blob>,
        AxiosError<ApiError>,
        InteractionListParams
    >({
        mutationFn: exportContactList,
        onSuccess: (res) => {
            const match = res.headers['content-disposition'].match(/filename\s*=\s*"(.+)"/i);
            const filename = match?.[1] || 'interactions.csv';
            fn.downloadFileFromBlob({
                blob: res.data,
                fileName: filename,
            });
        },
        onError: (error: AxiosError<ApiError>) => {
            const response = error.response?.data;
            const errorMessage = getApiErrors(response?.error, true);
            message.error({
                type: 'error',
                content: errorMessage || defaultErrorMessage,
            });
        },
    });

    return {
        exportInteractions,
    };
};

export default useInterationsActions;
